/**
 * Created by dreamc_t on 2017/2/14.
 */
var tmpl = require('./tabline.ejs');
require('./tabline.css');

//var options = {rtmp:[url1,url2,url3],list:list};




var tabline = function (options) {
    //console.log(options);
    this.options = options;
    this.init();
    this.initDomEvent();
};
tabline.prototype.init = function () {
    this.el = $(tmpl({list:this.options.list}));
};

tabline.prototype.initDomEvent = function () {
    var self = this;
    var len = $(this.el).find('.c-videoList__item').length;
    var itemDom = $(this.el).find('.c-videoList__item');
    $(this.el).on('click','[data-lineid]',function () {
        for(var i=0;i<len;i++){
            var item = itemDom[i];
            var lineid = $(this).data('lineid');
            if(i == lineid){
                $(item).addClass('clicked');
            }else{
                $(item).removeClass('clicked');
            }
        }
    });

    $(this.el).on('click','.c-handle--off',function () {
        self.el.animate({right:'-138px'});
        $(this).removeClass('c-handle--off');
        $(this).addClass('c-handle--on');
    });

    $(this.el).on('click','.c-handle--on',function () {
        self.el.animate({right:'0'});
        $(this).removeClass('c-handle--on');
        $(this).addClass('c-handle--off');
    });

};

tabline.prototype.renderTo = function (parenNode) {
    parenNode.append($(this.el));
};
module.exports = tabline;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.videohead.pc/app/modules/tabline/index.js